// Default look for react-select across the app (matches the Tailwind slate/blue inputs). A field with an error
// (the wrapper's ariaInvalid) is red like the text inputs next to it.
export const defaultSelectStyles = {
  control: (provided, state) => {
    const invalid = !!state.selectProps["aria-invalid"];
    return {
      ...provided,
      minHeight: "2.5rem",
      backgroundColor: state.isDisabled ? "#f1f5f9" : "#ffffff",
      borderWidth: "1px",
      borderRadius: "0.5rem",
      borderColor: invalid ? (state.isFocused ? "#ef4444" : "#fca5a5") : state.isFocused ? "#2563eb" : "#cbd5e1",
      boxShadow: state.isFocused
        ? invalid
          ? "0 0 0 4px rgb(239 68 68 / 0.15)"
          : "0 0 0 4px rgb(37 99 235 / 0.15)"
        : "0 1px 2px 0 rgb(0 0 0 / 0.05)",
      opacity: state.isDisabled ? 0.6 : 1,
      transition: "border-color 200ms, box-shadow 200ms",
      "&:hover": { borderColor: invalid ? "#f87171" : state.isFocused ? "#2563eb" : "#94a3b8" },
    };
  },
  valueContainer: (provided) => ({
    ...provided,
    paddingLeft: "0.75rem",
    fontSize: "14px",
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    paddingRight: "0.25rem",
  }),
  indicatorSeparator: () => ({ display: "none" }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    color: state.isFocused ? "#2563eb" : "#94a3b8",
    transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : "none",
    transition: "color 200ms, transform 200ms",
    "&:hover": { color: "#475569" },
  }),
  clearIndicator: (provided) => ({
    ...provided,
    color: "#94a3b8",
    "&:hover": { color: "#475569" },
  }),
  placeholder: (provided) => ({ ...provided, color: "#64748b" }),
  singleValue: (provided) => ({ ...provided, color: "#0f172a" }),
  input: (provided) => ({ ...provided, color: "#0f172a" }),
  menu: (provided) => ({
    ...provided,
    zIndex: 30,
    marginTop: "0.375rem",
    overflow: "hidden",
    borderRadius: "0.75rem",
    border: "1px solid #e2e8f0",
    boxShadow: "0 12px 32px -12px rgb(15 23 42 / 0.25)",
  }),
  menuList: (provided) => ({ ...provided, padding: "0.25rem" }),
  option: (provided, state) => ({
    ...provided,
    borderRadius: "0.5rem",
    fontSize: "14px",
    cursor: "pointer",
    color: state.isSelected ? "#ffffff" : "#0f172a",
    backgroundColor: state.isSelected
      ? "#2563eb"
      : state.isFocused
      ? "#eff6ff"
      : "transparent",
    "&:active": { backgroundColor: state.isSelected ? "#1d4ed8" : "#dbeafe" },
  }),
  multiValue: (provided) => ({
    ...provided,
    borderRadius: "0.375rem",
    backgroundColor: "#eff6ff",
  }),
  multiValueLabel: (provided) => ({ ...provided, color: "#1d4ed8" }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: "#3b82f6",
    borderRadius: "0.375rem",
    "&:hover": { backgroundColor: "#dbeafe", color: "#1d4ed8" },
  }),
  noOptionsMessage: (provided) => ({
    ...provided,
    fontSize: "14px",
    color: "#64748b",
  }),
  loadingMessage: (provided) => ({
    ...provided,
    fontSize: "14px",
    color: "#64748b",
  }),
};

export const selectTheme = (theme) => ({
  ...theme,
  borderRadius: 8,
  colors: {
    ...theme.colors,
    primary: "#2563eb",
    primary75: "#60a5fa",
    primary50: "#bfdbfe",
    primary25: "#eff6ff",
  },
});

export const landingSelect = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: "transparent",
    borderWidth: "2px",
    borderColor: "#813BE2",
    borderRadius: "12px",
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    textAlign: "center",
    fontSize: "16px",
    color: "#813BE2",
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    color: "#813BE2",
  }),
  placeholder: (provided) => {
    return {
      ...provided,
      color: "#813BE2",
    };
  },
  menu: (provided, state) => ({
    ...provided,
    // backgroundColor: 'transparent',
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: "transparent",
    color: "black",
  }),
};

export const navigationSelect = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: "transparent",
    borderWidth: "1px",
    borderColor: "#717c9e",
    borderRadius: "12px",
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    textAlign: "center",
    fontSize: "14px",
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
  }),
  placeholder: (provided) => {
    return {
      ...provided,
      color: "#374151",
    };
  },
  menu: (provided, state) => ({
    ...provided,
    // backgroundColor: 'transparent',
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: "transparent",
    color: "black",
  }),
};

// Filters in a row keep one line: a long placeholder ends with "…" instead of making the control taller.
export const filterSelectStyles = {
  ...defaultSelectStyles,
  placeholder: (provided, state) => ({
    ...defaultSelectStyles.placeholder(provided, state),
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  }),
};
